import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export function EmptyTreeState() {
  return (
    <div className="absolute inset-0 flex items-center justify-center z-20 overflow-hidden">
      <motion.div
        className="text-center px-4 sm:px-6 max-w-[90%] sm:max-w-md"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
      >
        {/* Glowing seed */}
        <motion.div
          className="mx-auto mb-6 w-16 h-16 rounded-full flex items-center justify-center"
          style={{
            background: 'radial-gradient(circle, rgba(255,215,100,0.3), rgba(255,215,100,0.05))',
            boxShadow: '0 0 40px rgba(255,215,100,0.2)',
          }}
          animate={{
            boxShadow: [
              '0 0 40px rgba(255,215,100,0.2)',
              '0 0 60px rgba(255,215,100,0.4)',
              '0 0 40px rgba(255,215,100,0.2)',
            ],
          }}
          transition={{ duration: 3, repeat: Infinity }}
        >
          <Sparkles className="h-7 w-7 text-amber-300" />
        </motion.div>

        <p className="text-white/80 text-base sm:text-lg font-medium mb-2 leading-snug">
          Your first message will plant the first fruit.
        </p>
        <p className="text-white/70 text-xs sm:text-sm mb-6">
          Each word grows something that lasts.
        </p>

        <Link to="/create">
          <Button
            size="lg"
            className="gap-2 rounded-2xl bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-black font-semibold shadow-lg shadow-amber-500/20 text-sm sm:text-base px-4 sm:px-6 whitespace-normal"
          >
            <Sparkles className="h-4 w-4 shrink-0" />
            Send your first Living Announcement
          </Button>
        </Link>
      </motion.div>
    </div>
  );
}
